import type { FormatterFactory } from '../types';

export interface MapValueOptions {
  mapping?: Record<string | number, string>;
  fallback?: string;
}

export const mapvalue: FormatterFactory = (options: MapValueOptions = {}) => {
  const mapping = options.mapping ?? {};
  return {
    toText: (value) => {
      const key = value as string | number;
      if (key != null && key in mapping) {
        return mapping[key];
      }
      return options.fallback ?? (value == null ? '' : String(value));
    },
  };
};
